import { useEffect } from 'react'
import { PaginatedCollection } from '@/api/types'
import { useApiQuery } from '@/api/main/query'
import { useToast } from '@/shared/hooks'
import { farmsAPI } from '../api'
import { AdminRequisitFarmListPayload } from 'syncra-api-client'

export const useFarmList = ({ skip, take }: { skip: number; take: number }) => {
  const { addToast } = useToast()

  const {
    data,
    error,
    isLoading,
  } = useApiQuery<PaginatedCollection<AdminRequisitFarmListPayload[]>>(
    ['farms', skip, take],
    farmsAPI.getMany(`${skip}`, `${take}`),
    undefined,
    { staleTime: 5000 }
  )
  useEffect(() => {
    if (error) {
      addToast('Ошибка!', error.message, 'error')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error])

  return {
    farmsData: data?.items || [],
    totalCount: data?.count || 0,
    isLoading,
    error,
  }
}
